import { AssetsService } from '@coosmo/shared-utils'

const goToStartIcon = AssetsService.getSvgIcon('go-to-start.svg')
const goToEndIcon = AssetsService.getSvgIcon('go-to-end.svg')

function getButtonsLargeIconsClass(largeIcons) {
  return largeIcons ? 'button-on-premises' : ''
}

function getLargeClass(largeIcons) {
  return largeIcons ? 'on-premises' : ''
}

function createPages(thumbLinks) {
  const thumbsHtml = thumbLinks
    .map((link, page) => {
      return `
<div class="lazy thumbnailLink ${page === 0 ? 'selected' : ''}" style="background-image: url('${link}')">
      <div id="thumbnailLinkIndex${page}" class="thumbnailLinkIndex">${page + 1}
      </div>
</div>`
    })
    .join('\n')

  return `
<div id="pagesThumbnails">
  ${thumbsHtml}
</div>
`
}

export default {
  createDOM: function (title, numberOfPages, largeIcons, thumbLinks) {
    return `
<div id="indexStrip" class="hidden ${getLargeClass(largeIcons)}">
    <div id="goToStartButton" class="go-to-button disabled ${getButtonsLargeIconsClass(largeIcons)}">
      <img src ="${goToStartIcon}">
    </div>

    <div id="goToEndButton" class="go-to-button ${getButtonsLargeIconsClass(largeIcons)}">
      <img src ="${goToEndIcon}">
    </div>

    <div id="pagesThumbnailsContainer">
      <div id="indexStripHeader" class="${getLargeClass(largeIcons)}">
        <div id="indexStripTitle">${title}</div>
        <div id="indexStripPositionLabel">
            <span id="indexStripPosition">1</span>&nbsp;/&nbsp;<span>${numberOfPages}</span>
        </div>
      </div>
      ${createPages(thumbLinks)}
    </div>
</div>
<div id="itemProgressBar" class="hidden">
    <div id="itemProgress" style='width: 0; transition: all ease 0.7s'"></div>
</div>
`
      .replace(/\n/g, '')
      .replace(/>\s+/g, '>')
  }
}
